import type { SearchListSuccess } from '@autobid/strapi-integration/typescript/auction/searchCars'
import type { CarFinishedEvent } from '@autobid/ui/types/websocket/CarFinishedEvent'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { searchCarsQueryKey } from '@autobid/ui/composables/car/data/useSearchCars'
import { SEARCH_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useSearchCarsSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'
import { useQueryClient } from '@tanstack/vue-query'

export function useSearchCarFinish() {
  const { startListen } = useWebSocketStore()
  const { updateSearchCar } = useUpdateCar()
  const queryClient = useQueryClient()

  const carFinished = () => {
    const updateFinishedCar = (event: CarFinishedEvent) => {
      const { carId, itemStatus } = event.context

      updateSearchCar(carId, (data) => {
        return {
          ...data,
          state: itemStatus,
          stage: 'FINISHED',
        }
      })
    }

    const prepareNextCar = (event: CarFinishedEvent) => {
      const { nextId } = event.context

      if (!nextId)
        return

      updateSearchCar(nextId, (data) => {
        return {
          ...data,
          stage: 'IN_AUCTION',
        }
      })
    }

    startListen({
      eventName: 'premium.CAR_FINISHED',
      callbackName: SEARCH_SOCKET_CALLBACK,
      callback: (event) => {
        /*
          courier sends double finish events, one of them is invalid and it will be fixed soon,
          the invalid event has input set to "premium"
        */
        if (event.input === 'premium')
          return

        updateFinishedCar(event)
        prepareNextCar(event)

        // !: order matters here invalidate the queries after all the sync. updates are done. Otherwise the query will be perceived as refreshed and will not be refetched
        queryClient.invalidateQueries({
          queryKey: searchCarsQueryKey.all(),
          predicate: (query) => {
            const queryData = query.state.data as SearchListSuccess['data']['items'] | undefined
            return queryData?.items?.some(item => item.id === event.context.carId) ?? false
          },
          refetchType: 'none',
        })
      },
    })
  }

  return { carFinished }
}
